// Build405: Italian editor localization; historical predecessor retained.
/* Build360: storefront login gate for manual production downloads only. */
(() => {
  'use strict';
  if (window.SmoofProductionAccess) return;
  const selector = '[data-smoof-customer-session]';
  const initial = document.querySelector(selector);
  let allowed = initial?.dataset.authenticated === 'true';
  function loginDestination(raw) {
    if (!raw) return '';
    try {
      const login = new URL(raw, location.origin);
      const target = new URL(location.href);
      for (const key of ['section_id', 'sections', '_smoof_session']) target.searchParams.delete(key);
      // Section rendering must never become the post-login landing page.
      login.searchParams.set(login.searchParams.has('return_to') ? 'return_to' : 'return_url', target.pathname + target.search + target.hash);
      return login.href;
    } catch (_) { return ''; }
  }
  let loginUrl = loginDestination(initial?.dataset.loginUrl);
  let pending = null;
  let failed = false;
  let checking = false;
  let restored = false;
  const english = () => /^en\b/i.test(document.documentElement.lang);
  const text = (de, en) => window.SmoofI18n.copy(de, en);
  function sync() {
    const format = Number(window.SmoofProductProfiles?.current?.surfaceCount) === 2 ? 'ZIP'
      : window.SmoofProductVariant?.get?.()?.printProcess === 'laser' ? 'SVG' : 'PDF';
    document.querySelectorAll('[data-smoof-ui-action="download-production"], [data-smoof-production-test-button]').forEach(button => {
      button.disabled = !allowed || checking;
      button.setAttribute('aria-disabled', String(button.disabled));
      if (button.matches('[data-smoof-ui-action]')) button.hidden = !allowed;
      const badge = button.querySelector('small');
      if (badge) badge.textContent = format + ' ↓';
    });
    document.querySelectorAll('[data-smoof-production-format]').forEach(node => {
      node.textContent = format === 'ZIP' ? text('ZIP · Vorder- und Rückseite', 'ZIP · Front and back') : format;
      node.hidden = allowed && format !== 'ZIP';
    });
    document.querySelectorAll('[data-smoof-production-login-note]').forEach(note => {
      note.hidden = allowed;
      const copy = note.querySelector('[data-smoof-production-login-copy]');
      if (copy) copy.textContent = text('Ihr Design bleibt erhalten.', 'Your design is preserved.');
      const link = note.querySelector('a');
      if (link) {
        link.hidden = !loginUrl;
        if (loginUrl) link.href = loginUrl;
        link.target = '_self';
        link.dataset.smoofDesignLogin = 'true';
      }
    });
    document.querySelectorAll('[data-smoof-production-status]').forEach(node => {
      node.textContent = checking ? text('Anmeldestatus wird geprüft …', 'Checking sign-in status …')
        : failed ? text('Der Anmeldestatus konnte nicht geprüft werden. Bitte versuchen Sie es erneut.', 'Your sign-in status could not be checked. Please try again.')
        : restored ? allowed ? text('Angemeldet. Ihr Design wurde wiederhergestellt.', 'Signed in. Your design has been restored.')
          : text('Ihr Design wurde wiederhergestellt. Melden Sie sich für den Produktionsdownload an.', 'Your design has been restored. Sign in to download the production file.') : '';
      node.hidden = !node.textContent;
    });
    document.querySelectorAll('[data-smoof-production-login-refresh]').forEach(button => {
      button.hidden = !failed;
      button.disabled = checking;
    });
  }
  window.addEventListener('smoof:login-draft-restored', () => { restored = true; sync(); });
  async function refresh() {
    if (pending) return pending;
    checking = true;
    sync();
    pending = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', 'smoof-customer-session');
        url.searchParams.set('_smoof_session', String(Date.now()));
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Session unavailable');
        const marker = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(selector);
        if (!marker || !['true', 'false'].includes(marker.dataset.authenticated)) throw new Error('Session missing');
        allowed = marker.dataset.authenticated === 'true';
        if (marker.dataset.loginUrl) loginUrl = loginDestination(marker.dataset.loginUrl);
        failed = false;
      } catch (_) {
        allowed = false;
        failed = true;
      } finally {
        clearTimeout(timeout);
        checking = false;
        sync();
      }
      return allowed;
    })();
    try { return await pending; } finally { pending = null; }
  }
  window.SmoofProductionAccess = Object.freeze({ version: '3.0.0', allowed: () => allowed && !checking, refresh, sync });
  window.addEventListener('focus', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-smoof-production-login-refresh]')) refresh();
  });
  sync();
})();
